export const REFERRER_DEPOSIT_DFI_BONUS = 30;
export const REFERRAL_DEPOSIT_DFI_BONUS = 10;

export const OLYMPIC_REFEREE_DEPOSIT_DFI_BONUS = 50;
export const OLYMPIC_REFERRER_DEPOSIT_DFI_BONUS = 25;
